import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "地区",
        key: "code",
        type: "select",
        required: true,
    },
    {
        name: "宗教场所",
        key: "宗教场所",
        type: "number",
    },
    {
        name: "港澳台同胞",
        key: "港澳台同胞",
        type: "number",
    },
    {
        name: "党派人士",
        key: "党派人士",
        type: "number",
    },
    {
        name: "无党派代表人士",
        key: "无党派代表人士",
        type: "number",
    },
    {
        name: "工商联会员",
        key: "工商联会员",
        type: "number",
    },
]

const ReligionCountEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const code = searchParams.get("code")
    const parentCode = searchParams.get("pcode")

    const [initFormData, setInitFormData] = useState({})
    const [regions, setRegions] = useState([])
    const [initFiles, setInitFiles] = useState({})

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (code) {
            ApiService.admin.regionStatistics.get(code)
                .onSuccess(data => {
                    setInitFormData({
                        code: data.code,
                        "宗教场所": data.properties["宗教场所"],
                        "港澳台同胞": data.properties["港澳台同胞"],
                        "党派人士": data.properties["党派人士"],
                        "无党派代表人士": data.properties["无党派代表人士"],
                        "工商联会员": data.properties["工商联会员"],
                    })
                })
        }

        ApiService.common.region.children(parentCode)
            .onSuccess(data => {
                setRegions(data.map(i => {
                    return {name: i.name, value: i.code}
                }))
            })
    }, [code, parentCode]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const handleFileChange = (change) => {
        changedFiles = {
            ...changedFiles,
            ...change
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false, {code: code})
            ApiService.admin.regionStatistics.update(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"统计信息管理"}
                formStruct={FORM}
                initValues={initFormData}
                initFiles={initFiles}
                selectOptions={{
                    code: regions
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
                onFileChange={handleFileChange}
            />
        </>
    )
}

export default ReligionCountEditPage